/*
 Copyright 2025 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

/**
 * Cite API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ScoringModelPermission = {
    ViewScoringModel: 'ViewScoringModel',
    EditScoringModel: 'EditScoringModel',
    ManageScoringModel: 'ManageScoringModel'
} as const;
export type ScoringModelPermission = typeof ScoringModelPermission[keyof typeof ScoringModelPermission];

